export var CSS_TRANSITION = name => "transition: " + name + " 0.12s ease-in;";